var _rect, _path, _g, _g2, _rect2, _rect3, _rect4, _g3, _rect5, _rect6, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutomationsEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 258,
    viewBox: "0 0 336 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 258,
    height: 258,
    rx: 129,
    fill: "#292836",
    fillOpacity: 0.06
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_32970",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 258,
    height: 259
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 128.5C0 -0.5 0 -0.5 129 -0.5C258 -0.5 258 -0.5 258 128.5C258 199.745 200.245 257.5 129 257.5C57.7553 257.5 0 199.745 0 128.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_32970)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_8_32970)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_8_32970",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3201 92.0481C87.2053 90.627 87.7516 88.9674 87.8405 87.1766C88.119 81.561 83.7923 76.7828 78.1767 76.5043C72.561 76.2258 67.7828 80.5524 67.5043 86.1681C67.2258 91.7837 71.5525 96.5619 77.1681 96.8404C77.9267 96.878 78.67 96.8316 79.389 96.7093C80.4315 98.4359 81.3669 100.618 82.1518 103.081C82.9594 105.615 83.5262 108.182 83.8904 110.352L63.3061 113.476C45.833 116.128 33.8178 132.442 36.4694 149.915L37.4874 156.623L30.8325 157.647C27.6126 158.143 26.2034 166.348 27.685 175.973C29.1665 185.599 32.9777 193 36.1976 192.505L42.7789 191.492L43.8776 198.732C45.2034 207.468 53.3605 213.476 62.097 212.15L144.237 199.685C152.973 198.359 158.981 190.202 157.655 181.466L156.361 172.94L161.257 172.187C164.477 171.691 165.886 163.486 164.405 153.861C162.923 144.235 159.112 136.834 155.892 137.329L151.07 138.071L150.247 132.649C147.595 115.176 131.281 103.161 113.808 105.812L92.1437 109.1C91.7197 106.54 91.0573 103.536 90.1046 100.546C89.2193 97.7684 88.0009 94.734 86.3201 92.0481Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3201 92.0481C87.2053 90.627 87.7516 88.9674 87.8405 87.1766C88.119 81.561 83.7923 76.7828 78.1767 76.5043C72.561 76.2258 67.7828 80.5524 67.5043 86.1681C67.2258 91.7837 71.5525 96.5619 77.1681 96.8404C77.9267 96.878 78.67 96.8316 79.389 96.7093C80.4315 98.4359 81.3669 100.618 82.1518 103.081C82.9594 105.615 83.5262 108.182 83.8904 110.352L63.3061 113.476C45.833 116.128 33.8178 132.442 36.4694 149.915L37.4874 156.623L30.8325 157.647C27.6126 158.143 26.2034 166.348 27.685 175.973C29.1665 185.599 32.9777 193 36.1976 192.505L42.7789 191.492L43.8776 198.732C45.2034 207.468 53.3605 213.476 62.097 212.15L144.237 199.685C152.973 198.359 158.981 190.202 157.655 181.466L156.361 172.94L161.257 172.187C164.477 171.691 165.886 163.486 164.405 153.861C162.923 144.235 159.112 136.834 155.892 137.329L151.07 138.071L150.247 132.649C147.595 115.176 131.281 103.161 113.808 105.812L92.1437 109.1C91.7197 106.54 91.0573 103.536 90.1046 100.546C89.2193 97.7684 88.0009 94.734 86.3201 92.0481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8405 87.1766L86.8417 87.1271L86.8417 87.1271L87.8405 87.1766ZM86.3201 92.0481L85.4713 91.5194L85.1412 92.0493L85.4724 92.5786L86.3201 92.0481ZM78.1767 76.5043L78.2262 75.5055L78.1767 76.5043ZM67.5043 86.1681L68.5031 86.2176L68.5031 86.2176L67.5043 86.1681ZM77.1681 96.8404L77.2177 95.8416L77.1681 96.8404ZM79.389 96.7093L80.245 96.1924L79.8929 95.6093L79.2213 95.7235L79.389 96.7093ZM82.1518 103.081L81.199 103.385L82.1518 103.081ZM83.8904 110.352L84.0405 111.341L85.0448 111.189L84.8766 110.187L83.8904 110.352ZM63.3061 113.476L63.4561 114.465L63.3061 113.476ZM36.4694 149.915L35.4808 150.065L36.4694 149.915ZM37.4874 156.623L37.6395 157.611L38.6258 157.459L38.4761 156.473L37.4874 156.623ZM42.7789 191.492L43.7676 191.342L43.6172 190.351L42.6267 190.503L42.7789 191.492ZM43.8776 198.732L42.8889 198.882L43.8776 198.732ZM62.097 212.15L61.947 211.161L61.947 211.161L62.097 212.15ZM144.237 199.685L144.087 198.696L144.237 199.685ZM157.655 181.466L156.666 181.616L157.655 181.466ZM156.361 172.94L156.209 171.952L155.223 172.104L155.373 173.09L156.361 172.94ZM151.07 138.071L150.081 138.221L150.232 139.212L151.222 139.06L151.07 138.071ZM150.247 132.649L151.236 132.499L150.247 132.649ZM113.808 105.812L113.658 104.823L113.808 105.812ZM92.1437 109.1L91.1572 109.263L91.3184 110.236L92.2938 110.088L92.1437 109.1ZM90.1046 100.546L91.0574 100.243L91.0574 100.243L90.1046 100.546ZM86.8417 87.1271C86.7615 88.7436 86.2689 90.239 85.4713 91.5194L87.1689 92.5768C88.1417 91.0151 88.7418 89.1911 88.8392 87.2261L86.8417 87.1271ZM78.1271 77.503C83.1912 77.7542 87.0928 82.063 86.8417 87.1271L88.8392 87.2262C89.1451 81.0589 84.3935 75.8114 78.2262 75.5055L78.1271 77.503ZM68.5031 86.2176C68.7543 81.1535 73.0631 77.2519 78.1271 77.503L78.2262 75.5055C72.0589 75.1996 66.8114 79.9512 66.5056 86.1185L68.5031 86.2176ZM77.2177 95.8416C72.1536 95.5905 68.252 91.2816 68.5031 86.2176L66.5056 86.1185C66.1997 92.2858 70.9513 97.5333 77.1186 97.8392L77.2177 95.8416ZM79.2213 95.7235C78.5736 95.8336 77.9031 95.8756 77.2177 95.8416L77.1186 97.8392C77.9503 97.8804 78.7664 97.8296 79.5566 97.6952L79.2213 95.7235ZM78.5329 97.2262C79.5236 98.8668 80.4301 100.972 81.199 103.385L83.1046 102.777C82.3038 100.265 81.3395 98.0049 80.245 96.1924L78.5329 97.2262ZM81.199 103.385C81.9894 105.865 82.5462 108.385 82.9042 110.518L84.8766 110.187C84.5063 107.98 83.9294 105.365 83.1046 102.777L81.199 103.385ZM83.7404 109.364L63.156 112.487L63.4561 114.465L84.0405 111.341L83.7404 109.364ZM63.156 112.487C45.1369 115.222 32.7463 132.046 35.4808 150.065L37.4581 149.765C34.8894 132.838 46.5291 117.033 63.4561 114.465L63.156 112.487ZM35.4808 150.065L36.4987 156.773L38.4761 156.473L37.4581 149.765L35.4808 150.065ZM37.3353 155.635L30.6804 156.659L30.9846 158.636L37.6395 157.611L37.3353 155.635ZM30.6804 156.659C29.4443 156.849 28.5381 157.756 27.9044 158.872C27.2638 160 26.8054 161.498 26.5101 163.217C25.9178 166.666 25.944 171.236 26.6966 176.125L28.6733 175.821C27.9444 171.085 27.9344 166.74 28.4813 163.556C28.7556 161.958 29.1606 160.71 29.6435 159.86C30.1333 158.997 30.6108 158.693 30.9846 158.636L30.6804 156.659ZM26.6966 176.125C27.4492 181.015 28.7984 185.381 30.4004 188.492C31.1988 190.043 32.0864 191.333 33.0366 192.217C33.9767 193.091 35.1136 193.683 36.3497 193.493L36.0455 191.516C35.6716 191.574 35.1248 191.427 34.3983 190.752C33.682 190.086 32.9205 189.018 32.1785 187.577C30.6994 184.704 29.4022 180.557 28.6733 175.821L26.6966 176.125ZM36.3497 193.493L42.931 192.48L42.6267 190.503L36.0455 191.516L36.3497 193.493ZM41.7902 191.642L42.8889 198.882L44.8663 198.582L43.7676 191.342L41.7902 191.642ZM42.8889 198.882C44.2976 208.164 52.9645 214.547 62.2471 213.139L61.947 211.161C53.7565 212.404 46.1092 206.772 44.8663 198.582L42.8889 198.882ZM62.2471 213.139L144.387 200.674L144.087 198.696L61.947 211.161L62.2471 213.139ZM144.387 200.674C153.669 199.265 160.053 190.598 158.644 181.315L156.666 181.616C157.909 189.806 152.277 197.453 144.087 198.696L144.387 200.674ZM158.644 181.315L157.35 172.79L155.373 173.09L156.666 181.616L158.644 181.315ZM156.514 173.929L161.41 173.175L161.105 171.198L156.209 171.952L156.514 173.929ZM161.41 173.175C162.646 172.985 163.552 172.078 164.186 170.962C164.826 169.833 165.285 168.336 165.58 166.617C166.172 163.168 166.146 158.598 165.393 153.708L163.417 154.013C164.146 158.749 164.156 163.094 163.609 166.278C163.334 167.876 162.929 169.123 162.446 169.974C161.957 170.836 161.479 171.141 161.105 171.198L161.41 173.175ZM165.393 153.708C164.641 148.819 163.291 144.453 161.69 141.342C160.891 139.791 160.004 138.5 159.053 137.617C158.113 136.743 156.976 136.151 155.74 136.341L156.044 138.318C156.418 138.26 156.965 138.407 157.692 139.082C158.408 139.748 159.169 140.816 159.911 142.257C161.39 145.13 162.688 149.277 163.417 154.013L165.393 153.708ZM155.74 136.341L150.918 137.083L151.222 139.06L156.044 138.318L155.74 136.341ZM152.059 137.921L151.236 132.499L149.258 132.799L150.081 138.221L152.059 137.921ZM151.236 132.499C148.501 114.48 131.677 102.089 113.658 104.823L113.958 106.801C130.885 104.232 146.69 115.872 149.258 132.799L151.236 132.499ZM113.658 104.823L91.9937 108.111L92.2938 110.088L113.958 106.801L113.658 104.823ZM93.1303 108.936C92.6999 106.338 92.0273 103.286 91.0574 100.243L89.1519 100.85C90.0873 103.785 90.7394 106.741 91.1572 109.263L93.1303 108.936ZM91.0574 100.243C90.1576 97.4195 88.9087 94.2997 87.1678 91.5176L85.4724 92.5786C87.093 95.1683 88.2809 98.1172 89.1519 100.85L91.0574 100.243Z",
    fill: "#EBEAEE",
    mask: "url(#path-3-inside-1_8_32970)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.4089 175.585C86.1434 186.854 96.6845 194.583 107.953 192.849C119.222 191.114 126.951 180.573 125.216 169.304L84.4089 175.585Z",
    fill: "#C4C4CE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.9983,
    cy: 147.288,
    rx: 7.43161,
    ry: 10.8518,
    transform: "rotate(-8.75009 74.9983 147.288)",
    fill: "#C4C4CE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.998,
    cy: 140.288,
    rx: 7.43161,
    ry: 10.8518,
    transform: "rotate(-8.75009 120.998 140.288)",
    fill: "#C4C4CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8057 121.553C63.2426 123.252 62.2195 124.983 60.5206 125.42C55.6874 126.663 52.0739 128.936 49.8575 132.11C47.6619 135.253 46.5581 139.679 47.4949 145.805C47.7601 147.539 46.5694 149.159 44.8353 149.424C43.1013 149.69 41.4806 148.499 41.2154 146.765C40.0902 139.408 41.3195 133.24 44.6495 128.472C47.9587 123.734 53.0633 120.778 58.9386 119.268C60.6375 118.831 62.3689 119.854 62.8057 121.553Z",
    fill: "#4F830F",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.3736,
    cy: 120.632,
    r: 3.17624,
    fill: "#4F830F",
    fillOpacity: 0.08
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_8_32970)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 21,
    width: 139.49,
    height: 73.8404,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.5,
    y: 21.5,
    width: 138.49,
    height: 72.8404,
    rx: 7.5,
    stroke: "#EBEAEE"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 32,
    width: 113,
    height: 12,
    rx: 6,
    fill: "#EBEAEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 48,
    width: 113,
    height: 12,
    rx: 6,
    fill: "#EBEAEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 64,
    width: 48,
    height: 12,
    rx: 6,
    fill: "#EBEAEE"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_8_32970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.047 150.086H306.59C307.779 150.086 308.957 149.852 310.056 149.397C311.155 148.942 312.153 148.274 312.995 147.433C313.836 146.592 314.503 145.594 314.958 144.495C315.413 143.396 315.648 142.218 315.648 141.028V111.053C315.648 108.652 314.694 106.35 312.996 104.652C311.298 102.954 308.995 102 306.594 102H185.105C183.916 101.999 182.738 102.233 181.64 102.687C180.541 103.142 179.543 103.808 178.701 104.649C177.86 105.489 177.193 106.486 176.737 107.585C176.282 108.683 176.047 109.86 176.047 111.049V140.686C176.047 141.219 175.998 141.753 175.873 142.271C174.121 149.545 169.857 150.038 169 150.082L176.047 150.086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.104 102.5H185.105H306.594C308.863 102.5 311.038 103.401 312.642 105.005C314.246 106.609 315.148 108.785 315.148 111.053V141.028C315.148 142.152 314.926 143.265 314.496 144.303C314.066 145.342 313.436 146.285 312.641 147.08C311.846 147.874 310.903 148.505 309.865 148.935C308.826 149.365 307.713 149.586 306.59 149.586H176.047H176.047L171.973 149.584C172.114 149.494 172.256 149.396 172.4 149.289C173.902 148.169 175.461 146.117 176.359 142.388C176.495 141.823 176.547 141.248 176.547 140.686V111.049C176.547 109.926 176.769 108.814 177.199 107.776C177.63 106.739 178.26 105.796 179.055 105.002C179.849 104.208 180.793 103.579 181.831 103.149C182.869 102.72 183.981 102.499 185.104 102.5Z",
    stroke: "#EBEAEE"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 189.504,
    y: 112.981,
    width: 53.1255,
    height: 26.0179,
    rx: 4,
    fill: "#4F830F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 249.53,
    y: 112.981,
    width: 53.1255,
    height: 26.0179,
    rx: 4,
    fill: "#4F830F14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.509 121.37C224.29 122.151 224.29 123.417 223.509 124.198L214.614 133.093L209.777 128.256C208.996 127.475 208.996 126.208 209.777 125.427C210.558 124.646 211.824 124.646 212.605 125.427L214.614 127.436L220.68 121.37C221.461 120.589 222.728 120.589 223.509 121.37Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M277.724 121.054C278.505 120.273 279.771 120.273 280.552 121.054C281.333 121.835 281.333 123.102 280.552 123.883L277.611 126.824L280.552 129.766C281.333 130.547 281.333 131.813 280.552 132.594C279.771 133.375 278.505 133.375 277.724 132.594L274.782 129.653L271.841 132.594C271.06 133.375 269.794 133.375 269.013 132.594C268.231 131.813 268.231 130.547 269.013 129.766L271.954 126.824L269.013 123.883C268.231 123.102 268.231 121.835 269.013 121.054C269.794 120.273 271.06 120.273 271.841 121.054L274.782 123.996L277.724 121.054Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_8_32970",
    x: 7.09595,
    y: 76.4915,
    width: 177.898,
    height: 175.842,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8_32970"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_32970"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8_32970"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8_32970",
    result: "effect2_dropShadow_8_32970"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8_32970",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_8_32970",
    x: 109,
    y: 21,
    width: 179.49,
    height: 113.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8_32970"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_32970"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8_32970"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8_32970",
    result: "effect2_dropShadow_8_32970"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8_32970",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_8_32970",
    x: 149,
    y: 102,
    width: 186.648,
    height: 88.0863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8_32970"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_32970"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8_32970"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8_32970",
    result: "effect2_dropShadow_8_32970"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8_32970",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationsEmptyState);
export default __webpack_public_path__ + "static/media/automations-empty-state.b672c105.svg";
export { ForwardRef as ReactComponent };